import { render } from "./zhuguanhushi-news.vue?vue&type=template&id=2838109a&scoped=true"
import script from "./zhuguanhushi-news.vue?vue&type=script&lang=js"
export * from "./zhuguanhushi-news.vue?vue&type=script&lang=js"

import "./zhuguanhushi-news.vue?vue&type=style&index=0&id=2838109a&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2838109a"]])

export default __exports__